import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import { instantItems } from '../data/content';
export function InstantAccess() {
  return <section className="w-full bg-chalk px-5 py-20 sm:py-28" data-id="element-122" data-mp="2582nt2k0r622">
      <div className="mx-auto max-w-2xl" data-id="element-123" data-mp="1r9uhw5508uer">
        <h2 className="text-center font-display text-[1.9rem] font-extrabold uppercase leading-tight text-ink sm:text-[2.6rem]" data-id="element-124" data-mp="1r8t4hu0invtv">
          <span aria-hidden="true" data-id="element-125" data-mp="1hj9l8n8w5zyh">📲 </span>What Do You Get Instantly?
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-126" data-mp="1hhgdt5qgfbpf">
          {instantItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl border border-ink/5 bg-white px-5 py-4 text-sm font-medium text-ink/85" data-id="element-127" data-mp="1mbazgepme0r5">
              <CircleCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-128" data-mp="1ckq3kz1bzabx" />
              {item}
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-2xl font-bold uppercase text-brand sm:text-3xl" data-id="element-129" data-mp="13iysfeo0ubao">
          You cover a full year of training for 6 different development levels.
        </p>
      </div>
    </section>;
}